import Clear from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useSearchParams} from 'react-router';
import {updatedSearchParams} from '../../utils.js';

function SearchField(props) {
  const [searchParams, setSearchParams] = useSearchParams();

  const query = searchParams.get('query') || '';
  const queryRef = useRef(query);

  const [rawTextInput, setRawTextInput] = useState(query);

  const handleReset = useCallback(() => {
    queryRef.current = '';
    setSearchParams(
      updatedSearchParams(searchParams, {
        query: '',
      }),
    );
    setRawTextInput('');
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (!query && queryRef.current) {
      handleReset();
    }
  }, [handleReset, query]);

  const handleSearch = useCallback(() => {
    if (rawTextInput) {
      queryRef.current = rawTextInput;
      setSearchParams(
        updatedSearchParams(searchParams, {
          query: rawTextInput,
        }),
      );
    }
  }, [rawTextInput, searchParams, setSearchParams]);

  const onKeyUp = useCallback(
    e => {
      if (e.key === 'Escape') {
        handleReset();
      }
      if (e.key === 'Enter') {
        handleSearch();
      }
    },
    [handleReset, handleSearch],
  );

  useEffect(() => {
    document.addEventListener('keyup', onKeyUp);

    return () => document.removeEventListener('keyup', onKeyUp);
  }, [onKeyUp]);

  const onBlur = useCallback(() => {
    if (rawTextInput !== query) {
      setRawTextInput(query);
    }
  }, [rawTextInput, query]);

  return (
    <TextField
      fullWidth
      label="Search publications"
      value={rawTextInput}
      onChange={e => setRawTextInput(e.target.value)}
      onBlur={onBlur}
      {...props}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              {query && query === rawTextInput ? (
                <IconButton
                  aria-label="clear search"
                  onClick={handleReset}
                  edge="end"
                >
                  <Clear />
                </IconButton>
              ) : (
                <IconButton onClick={handleSearch} edge="end">
                  <SearchIcon />
                </IconButton>
              )}
            </InputAdornment>
          ),
        },
      }}
    />
  );
}

export default SearchField;
